import clsx from 'clsx';
import SidebarCrossIcon from '../../assets/icons/sidebar-cross-icon.svg?react';
import FileIcon from '../../assets/icons/file-text.svg?react';
import React from 'react';
import { SubscriptionDetailsResponseDto } from '@EHSNavigator/backend';
import moment from 'moment';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';

interface TransactionHistoryModalProps {
  otherClasses?: string;
  handleClose: () => void;
  data: SubscriptionDetailsResponseDto;
}

const TransactionHistoryModal: React.FC<TransactionHistoryModalProps> = ({
  otherClasses,
  handleClose,
  data,
}) => {
  const transactionHistoryModalClasses = clsx(otherClasses, 'min-w-685');

  if (data?.manualSubscription) {
    return (
      <div className={transactionHistoryModalClasses} data-testid="transaction-history-modal">
        <div className="mb-6 flex w-full items-center justify-between">
          <h4 className="text-brand-byzantine">$ Transaction History</h4>
          <button className="cursor-pointer" onClick={handleClose}>
            <SidebarCrossIcon className="[&>g>path]:fill-brand-posh-pink h-6 w-6" />
          </button>
        </div>
        <div className="mt-10 flex flex-col items-center text-center">
          <WarningIcon className="[&>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />
          <h4 className="mt-15">Transaction history is not available for manual subscriptions</h4>
          <p className="font-inter-variable text-neutral-tones-text mt-4 text-base leading-5 font-normal">
            Please contact support for transaction details.
          </p>
        </div>
      </div>
    );
  }

  const transactionHistory = data?.subscription?.transactionHistory || [];

  return (
    <div
      className={transactionHistoryModalClasses}
      data-testid="transaction-history-modal"
    >
      <div className="mb-6 flex w-full items-center justify-between">
        <h4 className="text-brand-byzantine">$ Transaction History</h4>
        <button className="cursor-pointer" onClick={handleClose}>
          <SidebarCrossIcon className="[&>g>path]:fill-brand-posh-pink h-6 w-6" />
        </button>
      </div>
      {transactionHistory?.length > 0 ? (
        <div>
          <div className="border-b-neutral-tones-text/35 grid grid-cols-12 border-b pb-2.5">
            <p className="font-inter-variable text-neutral-tones-text col-span-3 text-sm leading-4 font-bold">
              Date
            </p>
            <p className="font-inter-variable text-neutral-tones-text col-span-2 text-sm leading-4 font-bold">
              Name
            </p>
            <p className="font-inter-variable text-neutral-tones-text col-span-2 text-sm leading-4 font-bold">
              Type
            </p>
            <p className="font-inter-variable text-neutral-tones-text col-span-2 text-sm leading-4 font-bold">
              Amount
            </p>
            <p className="font-inter-variable text-neutral-tones-text col-span-2 text-sm leading-4 font-bold">
              Status
            </p>
            <p className="font-inter-variable text-neutral-tones-text col-span-1 text-sm leading-4 font-bold">
              Invoice
            </p>
          </div>

          {transactionHistory?.map((node) => (
            <div className="border-b-neutral-tones-text/35 grid grid-cols-12 border-b py-2.5">
              <p className="font-inter-variable text-neutral-tones-text col-span-3 text-sm leading-4 font-normal capitalize">
                {moment(node?.date, 'DD/MM/YYYY').format('MMMM D, YYYY')}
              </p>
              <p className="font-inter-variable text-neutral-tones-text col-span-2 text-sm leading-4 font-normal capitalize">
                {node?.name}
              </p>
              <p className="font-inter-variable text-neutral-tones-text col-span-2 text-sm leading-4 font-normal capitalize">
                {node?.paymentMethodType}
              </p>
              <p className="font-inter-variable text-neutral-tones-text col-span-2 text-sm leading-4 font-normal capitalize">
                ${node?.amount}
              </p>
              <p
                className={clsx(
                  'font-inter-variable col-span-2 text-sm leading-4 font-bold capitalize',
                  node?.status === 'paid'
                    ? 'text-brand-papery'
                    : 'text-neutral-tones-text',
                )}
              >
                {node?.status}
              </p>
              <a
                href={node?.invoice_pdf}
                target="_blank"
                className="font-inter-variable text-brand-byzantine col-span-1 block text-sm leading-4 font-bold capitalize hover:underline"
              >
                <FileIcon className="[&>path]:stroke-brand-byzantine h-5 w-5" />
              </a>
            </div>
          ))}
        </div>
      ) : (
        <div className="mt-10 flex flex-col items-center text-center">
          <WarningIcon className="[&>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />
          <h4 className="mt-15">No transaction history found</h4>
        </div>
      )}
    </div>
  );
};

export default TransactionHistoryModal;
